import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Col, Row, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';
import AddressConfirmation from  './AddressConfirmation/AddressConfirmation'
import './AddressConfirmation/AddressConfirmation.scss';
import { isNull } from 'lodash-es';

const WaitingProduct = (
  {
    offer:{
      user_offer: {
        rewards_before_posting: rewards,
        id: uoId,
        is_address_confirmed: isAddressConfirmed
      }
    }
  }
) => {

  const { t } = useTranslation();
  const breakpoint = useBreakpoint();
  const [isAddressConfirmedAlert, setIsAddressConfirmedAlert] = useState(false);
  const [currentAddress, setCurrentAddress] = useState(null);

  const onSuccessAddressConfirmation = (address) => {
    setIsAddressConfirmedAlert(true);
    setCurrentAddress(address);
  }

  const currentShippingAddress = (shippingAddress) => {
    if (!isNull(currentAddress)) return currentAddress;
    else return shippingAddress;
  }

  return (
    <React.Fragment>
      {breakpoint !== 'xs' ?
        <h3 className="mb-4-5">{t('influencers.pages.campaign.status.waiting_product')}</h3> :
        <h4 className="mb-4-5">{t('influencers.pages.campaign.status.waiting_product')}</h4>}
      <p>
        {t('influencers.pages.campaign.status.desc_waiting_product')}
      </p>
      <Row>
        {rewards.map((reward) => {
          const {
            expected_ship_date: expectedShipDate,
            expected_delivery_date: expectedDeliveryDate,
            tracking_vendor: trackingVendor,
            tracking_number: trackingNumber,
            user_name: userName,
            reward_name: rewardName,
            id: id,
            shipping_address: shippingAddress
          } = reward;

          return <Col md={12} className="mb-3" key={id}>
            <Card>
              <Card.Header as="h6">{rewardName}</Card.Header>
              <Card.Body>
                {expectedShipDate && <React.Fragment>
                  <Row className="text-3">
                    <Col md={4}>
                      {t('influencers.pages.campaign.waiting_product.expected_ship_date')}
                    </Col>
                  </Row>
                  <Row md={4} className="text-1 mb-3">
                    <Col md={4}>
                      {expectedShipDate}
                    </Col>
                  </Row>
                </React.Fragment>}
                {expectedDeliveryDate && <React.Fragment>
                  <Row className="text-3" >
                    <Col md={4}>
                      {t('influencers.pages.campaign.waiting_product.expected_delivery_date')}
                    </Col>
                  </Row>
                  <Row className="text-1 mb-3">
                    <Col md={4}>
                      {expectedDeliveryDate}
                    </Col>
                  </Row>
                </React.Fragment>}
                {trackingVendor && <React.Fragment>
                  <Row md={4} className="text-3">
                    <Col md={4}>
                      {t('influencers.pages.campaign.waiting_product.tracking_number')}
                    </Col>
                  </Row>
                  <Row md={4} className="text-medium-1 mb-3">
                    <Col md={4}>
                      {trackingVendor}<br />
                      {trackingNumber}
                    </Col>
                  </Row>
                </React.Fragment>}
                {currentShippingAddress(shippingAddress) && <React.Fragment>
                  <Row md={4} className="text-3">
                    <Col md={4}>
                      {t('influencers.pages.campaign.waiting_product.shipping_address')}
                    </Col>
                  </Row>
                  <Row md={4} className="text-1 mb-3">
                    <Col md={4}>
                      {currentShippingAddress(shippingAddress)}
                    </Col>
                  </Row>
                  {
                    reward.staus != 'sent' &&
                    <AddressConfirmation
                      currentAddress={shippingAddress}
                      userOfferId={uoId}
                      isAddressConfirmed={isAddressConfirmed}
                      onSuccessCallback={(address) => onSuccessAddressConfirmation(address)}
                    />
                  }
                  {
                    (isAddressConfirmed || isAddressConfirmedAlert) &&
                    <Alert
                      variant="success"
                      className="mb-4 address-confirmed-alert d-flex align-items-center"
                    >
                      <i className="fas fa-check mr-2"></i>
                      <span>
                        {t("influencers.pages.campaign.waiting_product.address_confirmation.alert_body")}
                      </span>
                    </Alert>
                  }
                </React.Fragment>}
              </Card.Body>
            </Card>
          </Col>;
        })}
      </Row>

    </React.Fragment>);
};

WaitingProduct.propTypes = {
  offer: PropTypes.object.isRequired
};

export default WaitingProduct;